export const modulesConstants = {
    admins: "admins",
    eventGuestPhotos: "eventGuestPhotos",
    eventGuests: "eventGuests",
    eventPhotos: "eventPhotos",
    events: "events",
    eventSlideshow: "eventSlideshow",
    eventTemplates: "eventTemplates",
    headshotGuests: "headshotGuests",
    photographers: "photographers",
};
